var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78869",
    "data-name": "Group 78869",
    transform: "translate(-10408.75 896.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 26,
    transform: "translate(10409.25 -870.25) rotate(-90)",
    fill: "none",
    stroke: "#828282",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78866",
    "data-name": "Group 78866",
    transform: "translate(11303.75 9419.25) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146277",
    "data-name": "Rectangle 146277",
    width: 9,
    height: 21,
    rx: 1,
    transform: "translate(10293 -893)",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146278",
    "data-name": "Rectangle 146278",
    width: 9,
    height: 11,
    rx: 1,
    transform: "translate(10304 -893)",
    fill: "#828282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.af9da978ab222f8ba18a849db84b0a87.svg";
export { ForwardRef as ReactComponent };